module.exports = __webpack_public_path__ + "static/media/mpg-simple-icon.bf34d2c6.svg";